import dayjs from 'dayjs';

export const METERS_FIELD_ENABLED_DATE = {
	FROM: dayjs()
		.set('date', 25)
		.set('month', dayjs().month() - 1),
	TO: dayjs().set('date', 24).set('month', dayjs().month()),
};
